import React from 'react';
import ReactDOM from 'react-dom';
import FreeShortsSection from '../components/FreeShortsSection';
import { initializeI18n } from '../localization/i18n';
window.renderFreeShortsSection = (elementId, props) => {
  const el = document.getElementById(elementId);
  if (el) initializeI18n().then(() => ReactDOM.render(<FreeShortsSection props={props} />, el)).catch(() => {});
};
